import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';

@Component({
  selector: 'app-approvepop',
  templateUrl: './approvepop.component.html',
  styleUrls: ['./approvepop.component.css']
})
export class ApprovepopComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;


  @Input() formmode: string = "";
  @Input() formname: string = "";
  @Input() formid: any = 0;

  @Output() emitData = new EventEmitter();


  submitted: boolean;
  successfully: boolean;

  approveform = new FormGroup({
    reasondesc: new FormControl('', Validators.required),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

  }




  ngOnInit() {
    try {
      this.approveform.reset();
      this.fnInitializeFormGroup();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }

  fnInitializeFormGroup() {
    this.approveform.setValue({
      reasondesc: '',
    })


  }


  //Save Btn Click
  fnInsertApprove() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.approveform.valid) {
        var data = {
          formname: this.formname,
          trxid: this.formid,
          approvalstatus: this.formmode,
          reasondesc: this.approveform.get('reasondesc').value,
          approvedby: this.loginService.fnGetModUserId()
        }


        this.appService.fnInsertApprovals(data).subscribe(
          (res) => {

            if (res.json().status === 200) {
              var result = res.json().result;

              if (result.length>0) {                    
                if (result[0].checkstatus === 'DONE') {
                  this.emitData.emit("DONE");
                  this.activeModal.close(true);
                }               
                else  if (result[0].checkstatus === 'PAYROLL') {
                  this.toastr.error('Info', "Payroll Affected");
                }
                else  if (result[0].checkstatus === 'PAYMENT') {
                  this.toastr.error('Info', "Payment Applied");
                }
              }
              else {
                this.emitData.emit("DONE");
                this.activeModal.close(true);

              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
